export default __webpack_public_path__ + "fc526324226b683c1ae83693e43e1f40.png";